import { SVGProps } from 'react'

function SvgMaestro(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={70}
      height={48}
      viewBox="0 0 70 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <title>Maestro</title>
      <path
        d="M0 6a6 6 0 0 1 6-6h58a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 1H6a5 5 0 0 0-5 5v36a5 5 0 0 0 5 5h58a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5ZM6 0a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h58a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
        fill="#788BA5"
      />
      <path
        d="M40.19 24.254c0 7.625-6.11 13.806-13.648 13.806-7.537 0-13.647-6.181-13.647-13.806 0-7.625 6.11-13.806 13.647-13.806 7.538 0 13.648 6.181 13.648 13.806Z"
        fill="#ED0006"
      />
      <path
        d="M57.895 24.254c0 7.625-6.11 13.806-13.648 13.806-7.537 0-13.647-6.181-13.647-13.806 0-7.625 6.11-13.806 13.647-13.806 7.538 0 13.648 6.181 13.648 13.806Z"
        fill="#0099DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.395 13.746a13.841 13.841 0 0 1 4.795 10.508c0 4.208-1.86 7.976-4.795 10.508A13.841 13.841 0 0 1 30.6 24.254c0-4.208 1.86-7.976 4.795-10.508Z"
        fill="#6C6BBD"
      />
    </svg>
  )
}
export default SvgMaestro
